module.exports = __webpack_public_path__ + "static/media/traffic-moderate.842f603e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nxbus/traffic-moderate.svg
// module id = 783
// module chunks = 0